var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImcObesidadWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 52",
    style: {
      enableBackground: "new 0 0 33 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#105742;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#105742;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.4,8.9c2.5,0,4.5-2,4.5-4.4c0-2.5-2-4.4-4.5-4.4c-2.5,0-4.5,2-4.5,4.4C11.9,6.9,13.9,8.9,16.4,8.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.1,52c-1.3,0-2.3-1-2.3-2.3l-3.9-23c-0.5-0.8-0.8-1.6-0.9-2.3C7,24,7,23.6,7,23.3L5,27.1 c-1.1,1.7-4.6,0.6-4.2-2l5.4-10c0.9-2.9,3.1-5,6-5l9.4,0c3.2,0,5,3.2,6,5.5l4.5,8.6c0.7,3.6-3,4.5-4,1.8l-1.5-3.1 c0.1,0.5,0.1,1,0.1,1.6c-0.1,0.9-0.4,1.9-0.9,2.8l-3.6,22.4c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3l0-16.5h-1l0,16.5 C16.5,51,15.4,52,14.1,52z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImcObesidadWhite);
export default __webpack_public_path__ + "static/media/IMC_Obesidad_white.31b23e56.svg";
export { ForwardRef as ReactComponent };